import styled from "styled-components";

import colors from "@src/common/styles/colors";
import {
  DEFAULT_MARGIN_L,
  DEFAULT_MARGIN_M,
  DEFAULT_MARGIN_S,
} from "@src/common/styles/const";
import { defaultLetterSpacing, media } from "@src/common/styles/mixins";
import BaseModalWrapper from "@src/modules/shared/components/Modal/BaseModalWrapper";

export const ConfirmationModalWrapper = styled(BaseModalWrapper)`
  display: flex;
  gap: ${DEFAULT_MARGIN_M}px;
  flex-direction: column;
  width: 100%;
  max-width: 511px;
  margin: auto;
  background-color: ${colors.white};
  color: ${colors.almostBlack};
  font-weight: 600;
  font-size: 18px;
  ${defaultLetterSpacing};
  padding: ${DEFAULT_MARGIN_L}px;

  ${media.down("MOBILE")`
    margin: auto ${DEFAULT_MARGIN_M}px;
  `}
`;

export const ConfirmationModalButtons = styled.div`
  display: flex;
  // margin-top: ${DEFAULT_MARGIN_S}px;
  align-self: flex-end;
  gap: ${DEFAULT_MARGIN_M}px;
`;

export const ConfirmModalDescription = styled.p`
  font-size: 12px;
  font-weight: 400;
`;
